import React, { Component } from 'react';
import { render, unmountComponentAtNode as remove } from 'react-dom';
import PropTypes from 'prop-types';
import Popup from '../popup';

// Test data
import testData from './testData';

class Playbill extends Component {
  static propTypes = {
    route: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.timeline = null;

    this.state = {
      loading: true,
      data: false,
      days: [],
      // map: null,
      currentDay: null,
      wishlist: [],
      arrow: 'start',
      isDraggable: false,
    };
  }

  componentDidMount() {
    if (process.env.NODE_ENV === 'dev') {
      this.setState(
        {
          loading: false,
          data: testData.data,
          days: testData.map,
          currentDay: testData.map[0].date,
        },
        () => {
          this.startDrag();
          this.updateDrag();
          window.addEventListener('resize', () => this.updateDrag());
        },
      );
    } else {
      this.loadData();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDrag());
  }

  // Получаем универсальный iframe URL из любой ссылки
  getIframeUrl = (link) => {
    if (!link) return null;

    // Если ссылка уже содержит /embed/ - используем как есть
    if (link.includes('/embed/')) {
      // Добавляем autoplay если его нет
      if (link.includes('autoplay')) {
        return link;
      }
      return link.includes('?') ? `${link}&autoplay=1` : `${link}?autoplay=1`;
    }

    // YouTube - преобразуем различные форматы ссылок в embed
    const youtubeRegex = /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;
    const youtubeMatch = link.match(youtubeRegex);
    if (youtubeMatch && youtubeMatch[1] && youtubeMatch[1].length === 11) {
      return `//www.youtube.com/embed/${youtubeMatch[1]}?autoplay=1`;
    }

    // Rutube - преобразуем в embed формат
    const rutubeRegex = /(?:https?:\/\/)?(?:www\.)?rutube\.ru\/(?:video|play\/embed)\/([a-zA-Z0-9]+)/i;
    const rutubeMatch = link.match(rutubeRegex);
    if (rutubeMatch && rutubeMatch[1]) {
      return `//rutube.ru/play/embed/${rutubeMatch[1]}?autoplay=1`;
    }

    // Если ссылка уже выглядит как готовый iframe URL (начинается с http/https) - используем как есть
    if (link.match(/^https?:\/\//)) {
      return link.includes('autoplay') ? link : (link.includes('?') ? `${link}&autoplay=1` : `${link}?autoplay=1`);
    }

    // В остальных случаях возвращаем ссылку как есть (предполагая, что это уже готовый embed URL)
    return link;
  };

  // Показываем трейлер (через Magnific Popup, как btn--trailer на карточке фильма)
  showTrailer = (e, url) => {
    e.preventDefault();

    const iframeUrl = this.getIframeUrl(url);

    if (!iframeUrl) {
      console.error('Не удалось определить URL для видео');
      return;
    }

    $.magnificPopup.open({
      items: {
        src: iframeUrl,
      },
      type: 'iframe',
      mainClass: 'mfp-zoom-in',
      preloader: false,
    });
  };

  // Вывод попапа с результатом
  showPopup = (status, message, title) => {
    let popupTitle = status === 'success' ? 'Отлично!' : 'Ошибка';
    let popupMessage = '';

    if (title) popupTitle = title;

    if (message) popupMessage = message;

    $.magnificPopup.open({
      items: {
        src: '#popup',
      },
      removalDelay: 250,
      callbacks: {
        beforeOpen() {
          this.st.mainClass = 'mfp-anim';
        },
        open() {
          render(
            <Popup
              type="alert"
              status={status}
              title={popupTitle}
              message={popupMessage}
              button="Закрыть"
            />,
            $('#popup')[0],
          );
        },
        close() {
          remove($('#popup')[0]);
        },
      },
    });
  };

  showNotify = (filmName, isAuthorized) => {
    let text = '';
    if (isAuthorized) {
      text =
        '«' +
        filmName +
        '» добавлен <a href="/profile/wishlist">в&nbspизбранное</a>';
    } else {
      text = '<a href="/login">Авторизуйтесь</a> для добавления в избранное';
    }

    let div = document.createElement('div');
    div.className = 'notify__item';
    div.innerHTML =
      '<img src="/local/templates/comfortkino/static/img/icons/i-heart.svg" alt="like"/><p class="notify__text">' +
      text +
      '</p>';

    const elem = document.getElementById('notify-wrapper');
    elem.append(div);
  };

  getNav = arrow => {
    const { days } = this.state;
    const prevClass = ['nav__btn', 'nav__btn--prev'];
    const nextClass = ['nav__btn', 'nav__btn--next'];
    const env = process.env.NODE_ENV;
    const root = env !== 'dev' ? '/local/templates/comfortkino/' : '';

    switch (arrow) {
      case 'start':
        prevClass.push('disabled');
        break;
      case 'end':
        nextClass.push('disabled');
        break;
      default:
        break;
    }

    return (
      <div className="nav">
        <button
          className={prevClass.join(' ')}
          type="button"
          onClick={() => this.timeline.setStep(0)}
        >
          <svg width="20" height="23">
            <use href={`${root}static/img/icons/icons.svg#i-play-left`} />
          </svg>
        </button>
        <button
          className={nextClass.join(' ')}
          type="button"
          onClick={() => this.timeline.setStep(days.length)}
        >
          <svg width="20" height="23">
            <use href={`${root}static/img/icons/icons.svg#i-play-right`} />
          </svg>
        </button>
      </div>
    );
  };

  updateDrag() {
    const wrap = document.querySelector('.days__stage-outer');
    const inner = document.querySelector('.days__stage');

    if (this.timeline) {
      if (wrap.offsetWidth < inner.offsetWidth) {
        this.timeline.enable();
        this.setState({ isDraggable: true });
      } else {
        this.timeline.disable();
        this.setState({ isDraggable: false });
      }

      this.timeline.reflow();
    }
  }

  // Получаем данные
  loadData() {
    const { route } = this.props;

    const headers = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    // if (process.env.NODE_ENV != 'development') {
    // 	headers.credentials = 'include';
    // } else {
    // 	headers.headers.authorization = getAuth();
    // }

    fetch(route.main, headers)
      .then(response => response.json())
      .then(json => {
        if (json.status === 'success') {
          // const days = json.map;

          this.setState(
            {
              loading: false,
              data: json.data,
              // days: days,
              days: json.map,
              currentDay: json.map[0].date, // TODO проверка если нет дней (такое возможно?)
            },
            () => {
              this.startDrag();
              this.updateDrag();
              window.addEventListener('resize', () => this.updateDrag());
            },
          );
        } else if (json.status === 'error') {
          this.setState({
            loading: false,
          });

          this.showPopup(
            'error',
            json.errors.message || 'Что-то пошло не так. Попробуйте еще раз.',
          );
        }
      })
      .catch(() => {
        this.setState({
          loading: false,
        });

        this.showPopup('error', 'Что-то пошло не так.');
      });

    fetch(route.wishlist, headers)
      .then(response => response.json())
      .then(json => {
        if (json.status === 'success') {
          this.setState({
            wishlist: json.data,
          });
        }
      })
      .catch(() => {
        this.setState({
          loading: false,
        });

        this.showPopup('error', 'Что-то пошло не так.');
      });
  }

  startDrag() {
    const { days } = this.state;

    this.timeline = new Dragdealer('timeline-drag', {
      speed: 0.25,
      steps: days.length,
      handleClass: 'days__stage',
      animationCallback: x => {
        switch (x) {
          case 0:
            // console.log('0');
            this.setState({ arrow: 'start' });
            break;
          case 1:
            // console.log('1');
            this.setState({ arrow: 'end' });
            break;
          default:
            // console.log('all');
            this.setState({ arrow: '' });
            break;
        }
      },
    });

    this.setState({ isDraggable: true });
  }

  // Wishlist
  toggleFav(id, state, film) {
    const { route } = this.props;

    const formData = new FormData();

    formData.append('film', id.toString());
    formData.append('like', state === 0 ? 1 : 0);

    const headers = {
      method: 'POST',
      body: formData,
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    };

    fetch(route.like, headers)
      .then(response => response.json())
      .then(json => {
        // console.log(json);
        this.setState({
          wishlist: json.data.wishlist,
        });

        if (json.data.user.authorized && json.data.wishlist.includes(id)) {
          // this.showPopup('favorite');
          this.showNotify(film, true);
        }

        if (!json.data.user.authorized && json.data.wishlist.includes(id)) {
          this.showNotify(film, false);
        }
      })
      .catch(() => {
        this.showPopup('error', 'Что-то пошло не так.');
      });
  }

  render() {
    const {
      loading,
      data,
      days,
      currentDay,
      wishlist,
      arrow,
      isDraggable,
    } = this.state;

    if (loading || !data) {
      return (
        <div className="main-timeline">
          <div className="main-timeline__top">
            <div className="main-timeline__days days">
              <div className="main-timeline__title">
                <h1 className="heading heading--1">Загружаем сеансы...</h1>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // Кнопки переключения дней
    const daysBtns = days.map((day, index) => {
      const month = [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря',
      ];
      let dayForPeople = day.date.split('.');
      dayForPeople = `${dayForPeople[0]} ${
        month[parseInt(dayForPeople[1] - 1)]
      }`;

      const toggleDay = () => {
        if (day.empty) {
          return this.showPopup('empty_day');
        }

        return this.setState({ currentDay: day.date });
      };

      const classes = ['day'];

      if (day.date == currentDay) {
        classes.push('day--active');

        if (index === 7) {
          return (
            <React.Fragment key={index}>
              <div className="days__etc">
                <span />
              </div>
              <button
                key={`btn${day.date}`}
                className={classes.join(' ')}
                type="button"
              >
                <span className="day__week">{day.label}</span>
                <span className="day__date">{dayForPeople}</span>
              </button>
            </React.Fragment>
          );
        }

        return (
          <button
            key={`btn${day.date}`}
            className={classes.join(' ')}
            type="button"
          >
            <span className="day__week">{day.label}</span>
            <span className="day__date">{dayForPeople}</span>
          </button>
        );
      }

      if (index === 7) {
        if (day.empty === true) {
          classes.push('day--disabled');
        }

        return (
          <React.Fragment key={index}>
            <div className="days__etc">
              <span />
            </div>
            <button
              style={{ cursor: 'pointer' }}
              key={`btn${day.date}`}
              className={classes.join(' ')}
              onClick={() => toggleDay()}
              type="button"
            >
              <span className="day__week">{day.label}</span>
              <span className="day__date">{dayForPeople}</span>
            </button>
          </React.Fragment>
        );
      }

      if (day.empty === true) {
        classes.push('day--disabled');
      }

      return (
        <button
          style={{ cursor: 'pointer' }}
          key={`btn${day.date}`}
          className={classes.join(' ')}
          onClick={() => {
            if (isDraggable) this.timeline.setStep(index);
            toggleDay();
          }}
          type="button"
        >
          <span className="day__week">{day.label}</span>
          <span className="day__date">{dayForPeople}</span>
        </button>
      );
    });

    const filmsArr = data.filter(film => {
      if (currentDay in film.sessions) {
        let del = false;

        film.sessions[currentDay].forEach(session => {
          if (session.del) del = true;
        });

        if (film.sessions[currentDay].length < 2 && del) {
          return false;
        }

        return true;
      }

      return false;
    });

    filmsArr.sort((a, b) => {
      let a_len = 0;
      let b_len = 0;

      a.sessions[currentDay].forEach(ai => {
        if (!ai.del) a_len += 1;
      });

      b.sessions[currentDay].forEach(bi => {
        if (!bi.del) b_len += 1;
      });

      return a_len < b_len ? 1 : -1;
    });

    const films = filmsArr.map(film => {
      // Нет сеансов - ничего не выводим
      if (film.sessions[currentDay] === undefined) {
        return null;
      }

      const sessions = film.sessions[currentDay].map(session => {
        if (!session.del) {
          return (
            <li
              key={session.id}
              className={`timetable__item timetable__item--${session.format} ${
                session.disabled === true ? 'timetable__item--disabled' : ''
              }`}
            >
              <a href="#buy" data-session={session.id}>
                <span>{session.time}</span>
                {session.price_min === session.price_max ? (
                  <span className="price">{`${session.price} ₽`}</span>
                ) : (
                  <span className="price">{`от ${session.price_min} ₽`}</span>
                )}
              </a>
            </li>
          );
        }

        return null;
      });

      let imgRoute = '';

      if (process.env.NODE_ENV === 'dev') {
        imgRoute = 'https://almaz.comfortkino.ru';
      }

      film.like = 0;

      if (wishlist.indexOf(film.id) !== -1) film.like = 1;

      const favBtnClasses = ['main-btn btn btn--fav'];

      if (film.like === 1) favBtnClasses.push('btn--active');

      return (
        <div key={film.id} className="timeline-item">
          <div className="timeline-item__poster poster">
            {film.trailer ? (
              <button
                type="button"
                className="poster__trailer btn--trailer"
                onClick={e => this.showTrailer(e, film.trailer)}
              >
                <span className="poster__trailer-play">
                  <svg className="poster__trailer-icon" width="20" height="20">
                    <use
                      href={`${imgRoute}/local/templates/comfortkino/static/img/icons/icons.svg#i-play`}
                    />
                  </svg>
                </span>
                <span className="poster__trailer-caption">Смотреть трейлер</span>
              </button>
            ) : null}
            <a href={film.url} className="poster__body">
              {/* <span className="age">{film.age}</span> */}
              <span
                className="timeline-item__pic mob"
                style={{
                  backgroundImage: `url(${imgRoute}${film.poster.mobile})`,
                }}
              />
              <span
                className="timeline-item__pic desk"
                style={{
                  backgroundImage: `url(${imgRoute}${film.poster.desktop})`,
                }}
              />
            </a>
          </div>
          <div className="timeline-item__info">
            <div className="timeline-item__descr">
              <div className="top">
                <div className="top__left">
                  <div className="top__left-info">
                    <div className="top__left-content">
                      <p className="main-label">
                        <span>{film.country}</span>
                        <span>{film.genre}</span>
                        <span>{film.duration}</span>
                        <br />
                        {film.rent && (
                          <span>{film.rent}</span>
                        )}
                      </p>
                      <a href={film.url}>
                        <h2 className="main-title main-title--2 main-title--hover">
                          {film.name}
                        </h2>
                      </a>
                    </div>
                    <div className="age age--large">{film.age}</div>
                    <button
                      className={favBtnClasses.join(' ')}
                      type="button"
                      data-film={film.id}
                      data-like={film.like}
                      onClick={() =>
                        this.toggleFav(film.id, film.like, film.name)
                      }
                    >
                      <span>Хочу сходить</span>
                      <svg className="btn__icon btn__icon--star">
                        <use
                          href={`${imgRoute}/local/templates/comfortkino/static/img/icons/icons.svg#i-heart-filled`}
                        />
                      </svg>
                    </button>
                  </div>
                  {film.invites || film.sale || film.pushkin || film.childplace ? (
                    <div className="main-film__tags">
                      {film.invites ? (
                        <a
                          className="btn btn--tag btn--outline btn--white btn--link"
                          href={film.invites}
                        >
                          <svg
                            className="btn__icon btn__icon--ticket"
                            width="16"
                            height="16"
                          >
                            <use
                              href={`${imgRoute}/local/templates/comfortkino/static/img/icons/icons.svg#i-ticket-fill`}
                            />
                          </svg>
                          Пригласительные
                        </a>
                      ) : null}
                      {film.sale ? (
                        <a
                          className="btn btn--tag btn--outline btn--white"
                          href={film.sale}
                        >
                          <svg
                            className="btn__icon btn__icon--hot"
                            width="12"
                            height="14"
                          >
                            <use
                              href={`${imgRoute}/local/templates/comfortkino/static/img/icons/icons.svg#i-hot-fill`}
                            />
                          </svg>
                          Скидки
                        </a>
                      ) : null}
                      {film.pushkin ? (
                        <a
                          className="btn btn--tag btn--outline btn--white"
                          href={film.pushkin}
                        >
                          <svg
                            className="btn__icon btn__icon--hot"
                            width="12"
                            height="14"
                          >
                            <use
                              href={`${imgRoute}/local/templates/comfortkino/static/img/icons/icons.svg#i-pushkin`}
                            />
                          </svg>
                          Пушкинская карта
                        </a>
                      ) : null}
                      {film.childplace ? (
                        <a
                          className="btn btn--tag btn--outline btn--white"
                          href={film.childplace}
                        >
                          <svg
                            className="btn__icon btn__icon--hot"
                            width="12"
                            height="14"
                          >
                            <use
                              href={`${imgRoute}/local/templates/comfortkino/static/img/icons/icons.svg#i-childplace`}
                            />
                          </svg>
                          Детям бесплатно
                        </a>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="timeline-item__shedule">
              <div className="shedule">
                <div className="shedule__stage-outer">
                  <div className="shedule__stage">
                    <div className="shedule__day">
                      <ul className="timetable__list">{sessions}</ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });

    const notFullFilms = () => {
      if (filmsArr.length <= 3 && currentDay != days[0].date) {
        return (
          <div
            className="timeline-notfull"
            style={{
              backgroundImage:
                window.innerWidth >= 768
                  ? 'url("static/img/timeline/not-full.svg")'
                  : 'url("static/img/timeline/not-full-mob.svg")',
            }}
          >
            <img
              src="static/img/timeline/not-full-icon.svg"
              alt=""
              className="timeline-notfull__icon"
            />
            <p className="timeline-notfull__descr">
              Список сеансов сейчас неполный. Мы уже готовим полное расписание и
              скоро его загрузим.
            </p>
          </div>
        );
      }

      return null;
    };

    return (
      <div className="main-timeline">
        <div className="container">
          <h3 className="heading heading--1 main-timeline__title">
            Расписание сеансов
          </h3>
        </div>
        <div className="main-timeline__top">
          <div className="main-timeline__days days">
            {isDraggable ? this.getNav(arrow) : null}
            <div className="days__stage-outer" id="timeline-drag">
              <div className="days__stage">
                <div className="days__list">{daysBtns}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="main-timeline__body timeline">
          <div className="container">
            {films}
            {notFullFilms()}
          </div>
          <div className="notify__wrapper" id="notify-wrapper">
            {/* <div class="notify">Фильм "Оно" добавлен в избранное</div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default Playbill;
